import { Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material"
import Step01 from "./Step01"
import Step02 from "./Step02"
import Step03 from "./Step03"
import { useFormContext } from "react-hook-form"
import InfoStep01 from "./Step01/InfoStep01"
import InfoStep02 from "./Step02/InfoStep02"


export default function StepperIncluirRecb() {

    const { watch } = useFormContext()

    const activeStep = watch('stepper')

    const steps: Array<ISteps> = [
        {
            label: "Identificação",
            component: <Step01/>
        },
        {
            label: "Valores",
            component: <Step02/>
        },
        {
            label: "Outras informações",
            component: <Step03/>
        },
    ]

    const valoresOpcionais = [
        {component: <InfoStep01/>},
        {component: <InfoStep02/>},
    ]
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
        {
            steps.map((step, index) => (
                <Step key={step.label}>
                    <StepLabel
                    sx={{alignItems: 'flex-start'}}
                    optional={index < activeStep ? valoresOpcionais[index].component : null}
                    >   
                    <Typography marginBottom={2} color={activeStep === index ? '#000000' : 'rgba(0, 0, 0, 0.6)'} variant="subtitle1">{step.label}</Typography>
                        </StepLabel>
                    <StepContent>{step.component}</StepContent>
                </Step>
            ))
        }

    </Stepper>
  )
}

interface ISteps {
    label: TStepperTitle,
    component: React.ReactNode
}

type TStepperTitle = "Identificação" | "Valores" | "Outras informações"